if (process.env.REACT_APP_WEGLOT_KEY) {
    window.Weglot.initialize({
        api_key: process.env.REACT_APP_WEGLOT_KEY,
        hide_switcher: true,
    });
}

export default window.Weglot;
